/* Djurslottet - Om oss: lat inladdning och sparsam uppspelning av videolooparna.

   Sidan har nio loopar pa flera megabyte styck. Laddas de samtidigt konkurrerar de
   om samma uppkopplingar och ingen blir spelbar; spelas de samtidigt avkodas nio
   videostrommar parallellt och hela sidan blir trog. Darfor:

     - varje video bar sin URL i data-src och far den forst nar den narmar sig bild
     - HOGST TVA spelar samtidigt, de tva som syns mest just da
     - allt annat pausas direkt, sa avkodningen slutar

   2026-08-23: rootMargin sankt fran 250px till 40px och tak pa antal samtidiga
   strommar tillagt. Tidigare startade sex-sju loopar samtidigt pa en desktop-skarm. */
(function () {
  var vids = Array.prototype.slice.call(document.querySelectorAll('video[data-src]'));
  if (!vids.length) return;

  var MAX_PLAYING = 2;
  var ratios = new WeakMap();

  function load(v) {
    if (v.dataset.djLoaded) return;
    v.dataset.djLoaded = '1';
    v.src = v.getAttribute('data-src');
  }

  function play(v) {
    load(v);
    if (!v.paused) return;
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }

  function apply() {
    /* Sortera de synliga efter hur mycket av dem som syns, spela de tva basta. */
    var seen = [];
    for (var i = 0; i < vids.length; i++) {
      var r = ratios.get(vids[i]) || 0;
      if (r > 0) seen.push([r, vids[i]]);
    }
    seen.sort(function (a, b) { return b[0] - a[0]; });

    var keep = [];
    for (var j = 0; j < seen.length && j < MAX_PLAYING; j++) keep.push(seen[j][1]);

    for (var k = 0; k < vids.length; k++) {
      var v = vids[k];
      if (keep.indexOf(v) > -1) play(v);
      else if (!v.paused) v.pause();
    }
  }

  if (!('IntersectionObserver' in window)) {
    for (var i = 0; i < vids.length && i < MAX_PLAYING; i++) play(vids[i]);
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      ratios.set(e.target, e.isIntersecting ? e.intersectionRatio : 0);
    });
    apply();
  }, { rootMargin: '40px 0px', threshold: [0, 0.25, 0.5, 0.75, 1] });

  for (var n = 0; n < vids.length; n++) io.observe(vids[n]);
})();